"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("./styles");
function TableCell(_a) {
    var column = _a.column, row = _a.row, rowSpan = _a.rowSpan;
    var rowColumnText = [];
    var formatRowColumnText;
    var booleanClass;
    if (column.renderItem) {
        return (jsx_runtime_1.jsx(styles_1.CellContainer, __assign({ style: __assign({}, column.cssProps) }, { children: column.renderItem(row) }), column.title + "." + (Math.random() + new Date().getTime())));
    }
    if (Array.isArray(column.props)) {
        for (var i = 0; i < column.props.length; i += 1) {
            var key = column.props[i];
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            rowColumnText.push(row[key]);
        }
    }
    else {
        rowColumnText.push(row[column.props]);
    }
    function numberFixed(numero) {
        // @ts-ignore
        var numero = numero.toFixed(2).split('.');
        // @ts-ignore
        numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.');
        // @ts-ignore
        return numero.join(',');
    }
    switch (column.type) {
        case 'number': {
            formatRowColumnText = rowColumnText.reduce(function (text, item, index) {
                if (index === 0) {
                    return (Math.trunc(item * 100) / 100).toLocaleString('pt-BR');
                }
                return text + " " + (Math.trunc(item * 100) / 100).toLocaleString('pt-BR');
            }, '');
            break;
        }
        case 'currency':
            formatRowColumnText = new Intl.NumberFormat('pt-BR', {
                currency: 'BRL',
                style: 'currency',
            }).format(parseFloat(rowColumnText.join(' ').replace(',', '.')));
            break;
        case 'string':
            if (column.trunc &&
                rowColumnText.join(column.delimiter || ' ').length > column.trunc) {
                formatRowColumnText = rowColumnText
                    .join(column.delimiter || ' ')
                    .slice(0, column.trunc) + "...";
            }
            break;
        case 'date':
            if (rowColumnText[0]) {
                formatRowColumnText = new Date(rowColumnText[0]).toLocaleDateString();
            }
            else {
                formatRowColumnText = '';
            }
            break;
        case 'datetime': {
            if (rowColumnText[0]) {
                formatRowColumnText = new Date(rowColumnText[0]).toLocaleString();
            }
            else {
                formatRowColumnText = '';
            }
            break;
        }
        case 'time':
            formatRowColumnText = new Date(rowColumnText[0]).toLocaleTimeString();
            break;
        case 'boolean':
            if (rowColumnText.join(' ') === 'true') {
                booleanClass = 'true';
            }
            else {
                booleanClass = 'false';
            }
            break;
        case 'float':
            if (rowColumnText[0]) {
                formatRowColumnText = numberFixed(Number(rowColumnText[0]));
            }
            else {
                formatRowColumnText = '';
            }
            break;
        default:
            break;
    }
    if (column.formatter) {
        formatRowColumnText = column.formatter(row);
    }
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: column.type === 'colspan' ? (jsx_runtime_1.jsxs(styles_1.CellContainer, __assign({ boolean: booleanClass, stylePattern: column.type, positionPattern: column.position, style: __assign({}, column.cssProps), rowSpan: rowSpan }, { children: [jsx_runtime_1.jsx(styles_1.CellContainer, __assign({ boolean: booleanClass, stylePattern: column.type, positionPattern: column.position, style: __assign({}, column.cssProps), rowSpan: rowSpan }, { children: jsx_runtime_1.jsxs("div", __assign({ style: {
                            padding: '8px',
                            margin: 'auto',
                        } }, { children: [booleanClass &&
                                (booleanClass === 'true' ? jsx_runtime_1.jsx("p", { children: "Ativo" }, void 0) : jsx_runtime_1.jsx("p", { children: "Inativo" }, void 0)),
                            !booleanClass && (jsx_runtime_1.jsx("p", __assign({ style: __assign({}, column.cssText) }, { children: formatRowColumnText ||
                                    rowColumnText.join(column.delimiter || ' ') }), void 0))] }), void 0) }), column.title + "." + (Math.random() + new Date().getTime())),
                jsx_runtime_1.jsx(styles_1.CellContainer, __assign({ boolean: booleanClass, stylePattern: column.type, positionPattern: column.position, style: __assign({}, column.cssProps), rowSpan: rowSpan }, { children: jsx_runtime_1.jsxs("div", __assign({ style: {
                            padding: '8px',
                            margin: 'auto',
                        } }, { children: [booleanClass &&
                                (booleanClass === 'true' ? jsx_runtime_1.jsx("p", { children: "Ativo" }, void 0) : jsx_runtime_1.jsx("p", { children: "Inativo" }, void 0)),
                            !booleanClass && (jsx_runtime_1.jsx("p", __assign({ style: __assign({}, column.cssText) }, { children: formatRowColumnText ||
                                    rowColumnText.join(column.delimiter || ' ') }), void 0))] }), void 0) }), column.title + "." + (Math.random() + new Date().getTime())),
                jsx_runtime_1.jsx(styles_1.CellContainer, __assign({ boolean: booleanClass, stylePattern: column.type, positionPattern: column.position, style: __assign({}, column.cssProps), rowSpan: rowSpan }, { children: jsx_runtime_1.jsxs("div", __assign({ style: {
                            padding: '8px',
                            margin: 'auto',
                        } }, { children: [booleanClass &&
                                (booleanClass === 'true' ? jsx_runtime_1.jsx("p", { children: "Ativo" }, void 0) : jsx_runtime_1.jsx("p", { children: "Inativo" }, void 0)),
                            !booleanClass && (jsx_runtime_1.jsx("p", __assign({ style: __assign({}, column.cssText) }, { children: formatRowColumnText ||
                                    rowColumnText.join(column.delimiter || ' ') }), void 0))] }), void 0) }), column.title + "." + (Math.random() + new Date().getTime()))] }), column.title + "." + (Math.random() + new Date().getTime()))) : (jsx_runtime_1.jsx(styles_1.CellContainer, __assign({ boolean: booleanClass, stylePattern: column.type, style: __assign({}, column.cssProps) }, { children: jsx_runtime_1.jsxs("div", __assign({ style: {
                    padding: '8px',
                    margin: 'auto',
                } }, { children: [booleanClass &&
                        (booleanClass === 'true' ? jsx_runtime_1.jsx("p", { children: "Sim" }, void 0) : jsx_runtime_1.jsx("p", { children: "N\u00E3o" }, void 0)),
                    !booleanClass && (jsx_runtime_1.jsx("p", __assign({ style: __assign({}, column.cssText) }, { children: formatRowColumnText ||
                            rowColumnText.join(column.delimiter || ' ') }), void 0))] }), void 0) }), column.title + "." + (Math.random() + new Date().getTime()))) }, void 0));
}
exports.default = TableCell;
//# sourceMappingURL=TableCell.js.map